import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

interface ClientSearchProps {}

export const ClientSearch: React.FC<ClientSearchProps> = () => {
    const navigate = useNavigate();

    const [searchTerm, setSearchTerm] = useState("");

    const handleSearch = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        navigate(`/clients?p=1&search=${encodeURIComponent(searchTerm)}`);
    };

    return (
        <div className="filter clear" style={{ display: "block" }}>
            <form onSubmit={handleSearch}>
                <div className="content">
                    <p>
                        <label>
                            <strong>Otsing:</strong>
                        </label>
                        <input
                            className="text example"
                            type="text"
                            name="search"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        &nbsp;&nbsp;&nbsp;
                    </p>
                </div>
                <p className="action">
                    <button type="submit">
            <span>
              <strong>Otsi</strong>
            </span>
                    </button>
                    <Link to="/clients/new" className="filter-secondary">
                        Lisa uus klient
                    </Link>
                </p>
            </form>
        </div>
    );
};